import HaynesProFields from './HaynesProFields'
import { TLicenseTypeValues } from '@cbgms/api'
import { LicenseType } from '@carsys/enums/license-type'

interface IOptionalLicenseFieldsProps {
  licenseType: TLicenseTypeValues
}

const OptionalLicenseFields = ({ licenseType }: IOptionalLicenseFieldsProps) => {
  switch (licenseType) {
    case LicenseType.HaynesPro:
      return <HaynesProFields />
    default:
      return null
  }
}

export default OptionalLicenseFields
